<div class="building_shape" [ngClass]="{'active' : customFooter}" style="display: flex; justify-content: center;">
  <img src="./assets/images/img.svg" />
</div>
<footer class="footer" [ngClass]="{'mt-4' : !customFooter, 'custom': customFooter}">
  <div class="container">
    <!-- <div class="row"> -->
    <ul class="row">
      <li class="footer-logo col-md-4 my-auto">
        <a href="javascript:void(0);" (click)="goToThiqah()">
          <p>{{'Footer.developedBy' | translate}}</p>
          <img title="logo w-50" src="./assets/images/logo thiqah.svg">
        </a>
        <span></span>
        <a href="javascript:void(0);" (click)="goToMC()">
          <p>{{'Footer.under' | translate}}</p>
          <img src="./assets/images/mci__left--green.svg" alt="" />
        </a>
      </li>

      <li class="col-md-4 black logo-title text-center my-auto">
        {{"Footer.Monshaat" | translate}} {{"Footer.CopyRights" | translate}}
      </li>

      <li class="col-md-4 my-auto">
        <ul class="socialMediaSection text-right">
          <li class="social-icon twitter">
            <a target="_blank" href="https://twitter.com/MonshaatSA?s=1">
              <span class="icon-twitter"></span>
            </a>
          </li>
          <li class="social-icon facebook">
            <a target="_blank" href="https://www.facebook.com/MonshaatSA/">
              <span class="icon-facebook"></span>
            </a>
          </li>
          <li class="social-icon youtube">
            <a target="_blank" href="https://www.youtube.com/channel/UCajQIzMWeWK9bRQv5Ue3oUQ">
              <span class="icon-youtube-2"></span>
            </a>
          </li>
        </ul>
      </li>
    </ul>

    <!-- <div class="menu-footer-list col-12 col-md-6 col-lg-3  text-center text-lg-left mb-5 mb-lg-0">

      </div> -->

    <!-- <div class="col-md-6 text-center text-lg-left">
        <ul class="d-flex justify-content-center flex-wrap socialMediaSection">
          <li class="social-icon twitter">
            <a target="_blank" href="https://twitter.com/MonshaatSA?s=1">
              <span class="icon-twitter"></span>
            </a>
          </li>
          <li class="social-icon facebook">
            <a target="_blank" href="https://www.facebook.com/MonshaatSA/">
              <span class="icon-facebook"></span>
            </a>
          </li>
          <li class="social-icon youtube">
            <a target="_blank" href="https://www.youtube.com/channel/UCajQIzMWeWK9bRQv5Ue3oUQ">
              <span class="icon-youtube-2"></span>
            </a>
          </li>
        </ul>
      </div> -->
    <!-- </div> -->
  </div>
</footer>
